/**
 * The dark palette, in one place. Everything that needs a dark colour reads it from here:
 * the antd dark theme (`antdTheme.ts`), the nested attendance theme, and - through the parity
 * test in `palette.test.ts` - the `html[data-theme="dark"]` variables in `src/App.css`.
 * Change a colour here, then change the same variable in App.css; the test fails if they differ.
 *
 * Light values stay in `tokens.ts` and the `:root` block of App.css.
 */
export const darkPalette = {
  /** The page: the deepest tone. Cards sit one step lighter. */
  page: '#14161F',
  surface: '#1C1F2B',
  surfaceRaised: '#252938',
  border: '#323747',
  borderStrong: '#434A5E',
  text: '#E8EAF2',
  textSecondary: '#A9AFC2',
  /** Accent for text, links and icons on dark. */
  accent: '#818CF8',
  accentInk: '#C7D2FE',
  /** Fill for primary buttons: white text on it is 4.5:1 or better. */
  accentFill: '#5458E8',
  /** The sidebar, in both modes. */
  rail: '#1E1B4B',
  railActive: '#3B37A0',
  railHover: '#2A2763',
  railInk: '#C7CAF0',
} as const;

/** CSS variable -> palette value, the ones the parity test checks in App.css. */
export const darkCssVars: Record<string, string> = {
  '--bg-main': darkPalette.surface,
  '--bg-hover': darkPalette.surfaceRaised,
  '--bg-layout': darkPalette.page,
  '--border-light': darkPalette.border,
  '--border-medium': darkPalette.borderStrong,
  '--text-primary': darkPalette.text,
  '--primary': darkPalette.accent,
  '--primary-darker': darkPalette.accentInk,
};
